var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"test"}},[(_vm.ueditorData.flag)?_c('ueditor-dialog',{attrs:{"width":_vm.ueditorData.width,"title":_vm.ueditorData.title,"content":_vm.ueditorData.content}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }